module.exports = __webpack_public_path__ + "img/logo.b83de6d2.png";